import React from 'react';

const TABS = [
  { key: 'edit', label: 'Edit' },
  { key: 'preview', label: 'Preview' },
];

const MobileViewToggle = ({ value, onChange, className = '' }) => {
  return (
    <div className='md:hidden w-full p-4'>
      <div
        className={`w-full flex items-center p-1 bg-grayscale-gray02/50 rounded-[20px] ${className}`}
      >
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type='button'
            onClick={() => onChange(tab.key)}
            className={`flex-1 p-2 rounded-[15px] text-center typo-b13Strong ${
              value === tab.key
                ? 'bg-grayscale-gray00 shadow-3 text-text-primary'
                : 'text-text-secondary'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileViewToggle;
